<template>
  <!-- 进出口信用 -->
  <div>
    <block>
      <div id="importExportCount" style="position: relative;height: 0;overflow: hidden;top: -120px;"></div>
      <div class="table-list-title dis-bet-cen">
        <div>进出口信用 <span style="color: #5D6FE9;">{{page.total}}</span></div>
      </div>
      <el-table
        border
        :data="TableData"
        :cell-style="cellStyle"
        :header-cell-style="headerColor"
        style="width: 100%;">
        <el-table-column type="index" width="50" label="序号"></el-table-column>
        <el-table-column v-for="(item,index) in tableHeader" :key="index" :label="item.label" :property="item.property" align="center">
          <template #default="scope">
            <el-button v-if="scope.column.property == 'handleImg'">预览</el-button>
            <el-button v-else-if="scope.column.property == 'handleDetails'">详情</el-button>
            <span v-else>{{scope.row[scope.column.property] || '-'}}</span>
          </template>
        </el-table-column>
        <el-table-column
            label="操作"
            width="80">
            <template #default="scope">
             <el-button type="text" @click="handleTo(scope.row)">详情</el-button>
            </template>
          </el-table-column>
      </el-table>
      <div class="table-page">
        <el-pagination
          background
          hide-on-single-page="true"
          :page-size="10"
          :pager-count="7"
          layout="prev, pager, next"
          v-model:currentPage="page.pageNum"
          @current-change="pageChange"
          :total="page.total">
        </el-pagination>
      </div>
      <el-dialog title="进出口信用详情" :append-to-body="appendtobody" v-model="dialogTableVisible">
          <el-descriptions class="margin-top"  :column="2" :size="size" border>
            <el-descriptions-item :span="1">
              <template #label>海关注册编码</template>
              {{companyDetail.regNo || '-'}}
            </el-descriptions-item>
            <el-descriptions-item :span="1">
              <template #label>注册海关</template>
              {{companyDetail.regGov || '-'}}
            </el-descriptions-item>
            <el-descriptions-item :span="1">
              <template #label>行政地区</template>
              {{companyDetail.administrativeArea || '-'}}
            </el-descriptions-item>
            <el-descriptions-item :span="1">
              <template #label>经济地区</template>
              {{companyDetail.economicArea || '-'}}
            </el-descriptions-item>
            <el-descriptions-item :span="1">
              <template #label>经营类别</template>
              {{companyDetail.tradeType || '-'}}
            </el-descriptions-item>
            <el-descriptions-item :span="1">
              <template #label>特殊贸易区域</template>
              {{companyDetail.cancellationFlag || '-'}}
            </el-descriptions-item>
            <el-descriptions-item :span="1">
              <template #label>海关注销标志</template>
              {{companyDetail.cancellationFlag || '-'}}
            </el-descriptions-item>
            <el-descriptions-item :span="1">
              <template #label>年报情况</template>
              {{companyDetail.annualStatus || '-'}}
            </el-descriptions-item>
            <el-descriptions-item :span="1">
              <template #label>注册日期</template>
              {{companyDetail.regDate || '-'}}
            </el-descriptions-item>
            <el-descriptions-item :span="1">
              <template #label>报关有效期</template>
              {{companyDetail.expireDate || '-'}}
            </el-descriptions-item>
            <el-descriptions-item :span="1">
              <template #label>行业种类</template>
              {{companyDetail.industryType || '-'}}
            </el-descriptions-item>
            <el-descriptions-item :span="1">
              <template #label>跨境贸易电子商务类型</template>
              {{companyDetail.ebusinessType || '-'}}
            </el-descriptions-item>
            <el-descriptions-item :span="1">
              <template #label>信用等级</template>
              {{companyDetail.creditGrade || '-'}}
            </el-descriptions-item>
            <el-descriptions-item :span="1">
              <template #label> 海关行政处罚</template>
              {{companyDetail.punishInfo || '-'}}
            </el-descriptions-item>
          </el-descriptions>
      </el-dialog>
    </block>
  </div>
</template>

<script>
import { forwardBG } from '@/api/forward.js'
export default {
  name: 'import-export-count',
  props: { companyId: String },
  data () {
    return {
      appendtobody: true,
      companyDetail: {},
      dialogTableVisible: false,
      page: {
        total: 0,
        pageNum: 1
      },
      // 股东信息
      tableHeader: [{
        label: '注册海关',
        property: 'regGov'
      }, {
        label: '海关注册编号',
        property: 'regNo'
      }, {
        label: '经营类别',
        property: 'tradeType'
      }, {
        label: '注册日期',
        property: 'regDate'
      }],
      TableData: []
    }
  },
  mounted () {
    this.initData()
  },
  methods: {
    handleTo (e) {
      this.dialogTableVisible = true
      const vm = this
      const data = {
        dateBackgroundUrl: '/ImportExport/getImportExportDetail',
        dateBackgroundRequestType: 'get',
        data: {
          ieId: vm.companyId
        }
      }
      forwardBG(data).then(result => {
        if (result.code === 0) {
          const res = result.data
          this.companyDetail = res
          console.log(res)
        }
      }).catch(error => {
        console.log(error)
      })
    },
    // 表格设置样式
    headerColor: function ({ row, column, rowIndex, columnIndex }) {
      return 'background-color:#E8EBFC;color:#666666;font-size:14px;text-align:center'
    },
    cellStyle: function ({ row, column, rowIndex, columnIndex }) {
      return 'text-align:center'
    },
    pageChange (e) {
      this.page.pageNum = e
      this.initData()
    },
    initData: function () {
      const vm = this
      const data = {
        dateBackgroundUrl: '/ImportExport/getImportExportList',
        dateBackgroundRequestType: 'get',
        data: {
          qccCompanyId: vm.companyId,
          pageNum: vm.page.pageNum,
          pageSize: 10
        }
      }
      forwardBG(data).then(result => {
        if (result.code === 0) {
          const res = result.data
          const arr = []
          vm.page.total = res.total
          res.list.forEach(item => {
            item.regDate = item.regDate ? item.regDate.substring(0, 10) : '-'
            arr.push(item)
          })
          vm.TableData = arr
        }
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>

<style scoped="scoped" lang="less">
.table-list-title {
  padding: 18px 0;
  text-align: left;
  color: #333;
  font-weight: bold;
}
.table-page {
  text-align: right;
  margin-top: 10px;
}
</style>
